import { personSystemAlias } from '../../utils/personnel';
export const fullName = person => [person.first_name, person.last_name].filter(Boolean).join(' ').trim();
const normalize = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').trim();
export const valueFor = (person, field) => field === 'name' ? fullName(person) : field === 'nickname' ? personSystemAlias(person) : String(person[field] ?? '');
export function employeeList(people, { search = '', filter = 'all', showInactive = false, sort = 'name', direction = 'asc' } = {}) {
  const fields = filter === 'all' ? ['name', 'nickname', 'cedula', 'operational_role', 'contract_company'] : [filter];
  const query = normalize(search);
  return people.filter(p => !p.hidden_from_employee_directory && (showInactive || p.active) && fields.some(field => {
    const value = normalize(valueFor(p, field));
    if (value.includes(query)) return true;
    return field === 'cedula' && /\d/.test(query) && value.replace(/\D/g, '').includes(query.replace(/\D/g, '')) && /^[\d.\s-]+$/.test(query);
  })).sort((a, b) => {
    const left = valueFor(a, sort).trim(), right = valueFor(b, sort).trim();
    if (!left && right) return 1;
    if (left && !right) return -1;
    const comparison = left.localeCompare(right, 'es', { sensitivity: 'base', numeric: true });
    return (direction === 'desc' ? -comparison : comparison) || fullName(a).localeCompare(fullName(b), 'es', { sensitivity: 'base' }) || Number(a.id) - Number(b.id);
  });
}
export function employeeGroups(people, group = '', dateUnit = '') {
  if (!group || (group === 'employment_start_date' && !dateUnit)) return [{ key: '', label: '', people }];
  const groups = new Map();
  people.forEach(person => {
    const raw = valueFor(person, group).trim();
    const key = group === 'employment_start_date' ? raw.slice(0, dateUnit === 'year' ? 4 : 7) : normalize(raw);
    let label = raw;
    if (!raw) label = group === 'contract_company' ? 'Sin Empresa contrato' : group === 'operational_role' ? 'Sin Rol' : group === 'work_team' ? 'Sin Equipo' : 'Sin Fecha de inicio';
    else if (group === 'employment_start_date') label = dateUnit === 'year' ? key : `${key.slice(5, 7)}/${key.slice(0, 4)}`;
    if (!groups.has(key)) groups.set(key, { key, label, people: [] });
    groups.get(key).people.push(person);
  });
  return [...groups.values()].sort((a, b) => !a.key ? 1 : !b.key ? -1 : a.key.localeCompare(b.key, 'es', { numeric: true }));
}
